// removed by extract-text-webpack-plugin
module.exports = {"root":"components-Honeycomb-__index__root__cX-W2"};


//////////////////
// WEBPACK FOOTER
// ./components/Honeycomb/index.css
// module id = 819
// module chunks = 0